import { getCommonFieldsPayload } from './getCommonFieldsPayload';
export const getTextPostPayload = (values) => {
    return getCommonFieldsPayload(values);
};
